import React from "react";
import ComingSoon from "./ComingSoon";

const MySchedule = () => {
  return (
    <div>
      <ComingSoon />
    </div>
  );
};

export default MySchedule;
